import logger from '../../../shared/services/logging/logger';

/**
 * Determines folder name from endpoint data and optional test configuration
 *
 * @param {Object} endpoint - The endpoint object containing method and path
 * @param {string} endpoint.method - HTTP method (GET, POST, etc.)
 * @param {string} endpoint.path - API endpoint path
 * @param {Object|null} testConfigData - Optional test configuration data
 * @returns {string} Sanitized folder name
 */
export const getFolderNameFromEndpoint = (endpoint, testConfigData = null) => {
  const testName = testConfigData?.tests?.[0]?.name;
  let folderName;

  if (testName) {
    // Use test name from config if available
    folderName = testName
      .replace(/[<>:"/\\|?*]/g, '')
      .replace(/\s+/g, '_')
      .trim();
  } else {
    // Fallback to method + path
    const pathPart = endpoint.path.replace(/[\/{}]/g, '_').replace(/^_|_$/g, '');
    folderName = `${endpoint.method.toUpperCase()}_${pathPart}`.replace(/__+/g, '_');
  }

  logger.debug('Generated folder name', {
    method: endpoint.method,
    path: endpoint.path,
    hasTestName: !!testName,
    folderName
  });

  return folderName;
};
